import * as z from 'zod';

export const InitialBalances = z.object({
  interest: z.number(),
  escrow: z.number(),
  principal: z.number(),
  principalPrepayment: z.number(),
  futureStatementSuspense: z.number().default(0),
  unappliedSuspense: z.number().default(0),
  reserve: z.number().optional(),
  mortgageInsurance: z.number().optional(),
  fee: z.number().optional(),
  holdback: z.number().optional(),
  nonInterestBearingUnpaidPrincipal: z.number().optional(), // Deferred to payoff prior to boarding
});
export type InitialBalances = z.infer<typeof InitialBalances>;
